import Spinner from './assets/Spinner';

const Loading = ({ width = '120px', height = '120px' }: { width?: string, height?: string }) => (
  <div className="w-full inline-flex flex-col justify-center items-center flex-nowrap py-5">
    <Spinner width={width} height={height} />
    <span className="text-primary-200 text-sm font-bold">Loading...</span>
  </div>
);

export default Loading;
